import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    loaded: false,
    loadedMessagesOutput: false,
    loadedMessagesInput: false,
    loadedMessagesMailing: false,
    loadedClientsSubscribe: false,
    loadedClientsUnsubscribe: false,
    messageRating: [],
    messagesToday: {
        output: 0,
        input: 0,
        mailing: 0
    },
    clientsToday: {
        subscribe: 0,
        unsubscribe: 0
    },
    messagesSendInfo: {
        labels: [],
        mailing: [],
        output: [],
        input: []
    },
    clientsInfo: {
        labels: [],
        subscribe: [],
        unsubscribe: []
    },
    modelDefault: {
        id: null,
        bot_id: null
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
